import storage from 'jsx/utils/storage';
import cookie from 'jsx/utils/cookie';

/**
 * A "toggle" of sorts for saving local storage key:value pairs
 */
export const setWithNullHandling = (key: string, reason: string | null) => {
  if (reason === null) {
    storage.remove(key);
  } else {
    storage.set(key, reason);
  }
};

export const setCookieWithNullHandling = (
  key: string,
  reason: string | null,
) => {
  if (reason === null) {
    cookie.remove(key);
  } else {
    cookie.set(key, reason);
  }
};

export const getFromCookieOrStorage = (key: string) => {
  return cookie.get(key) || storage.get(key) || null;
};

export const removeFromCookieAndStorage = (key: string) => {
  cookie.remove(key);
  storage.remove(key);
};
